import React from "react"
import { Link } from "gatsby"

import * as classes from "../styles/breadcrumb.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse } from "@fortawesome/free-solid-svg-icons"

const Breadcrumb = ({ cat0, cat1, title }) => {
  return (
    <div id="breadcrumb" className={classes.breadcrumb}>
      <ol className={`${classes.breadcrumb__list} l-container`}>
        <li className={classes.breadcrumb__item}>
          <Link to={`/`} className={classes.breadcrumb__text}>
            <FontAwesomeIcon icon={faHouse} className={classes.icon_home} />
            <span>ホーム</span>
          </Link>
        </li>
        {cat0 && (
          <li className={classes.breadcrumb__item}>
            <Link
              to={`/area/${cat0.slug}/`}
              className={classes.breadcrumb__text}
            >
              <span>{cat0.title}</span>
            </Link>
          </li>
        )}
        {cat1 && (
          <li className={classes.breadcrumb__item}>
            <Link
              to={`/area/${cat0.slug}/${cat1.slug}/`}
              className={classes.breadcrumb__text}
            >
              <span>{cat1.title}</span>
            </Link>
          </li>
        )}
        <li className={classes.breadcrumb__item}>
          <span className={classes.breadcrumb__text}>{title}</span>
        </li>
      </ol>
    </div>
  )
}

export default Breadcrumb
